import { render, staticRenderFns } from "./detailTable13.vue?vue&type=template&id=129377d0&scoped=true"
import script from "./detailTable13.vue?vue&type=script&lang=js"
export * from "./detailTable13.vue?vue&type=script&lang=js"
import style0 from "./detailTable13.vue?vue&type=style&index=0&id=129377d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129377d0",
  null
  
)

export default component.exports